import React from "react";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { initLenis, scrollToTopImmediate, scrollToSection } from "@/lib/scroll";
import { AuthProvider } from "@/context/AuthContext";
import Home from "@/pages/Home";
import Account from "@/pages/Account";
import AuthCallback from "@/pages/AuthCallback";
import { PrivacyPage, TermsPage } from "@/pages/Legal";

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { error: null };
    }
    static getDerivedStateFromError(error) {
        return { error };
    }
    render() {
        if (this.state.error) {
            return (
                <div style={{ padding: 48, fontFamily: "Manrope, sans-serif" }}>
                    <h1>Something went wrong</h1>
                    <p>Please refresh the page.</p>
                </div>
            );
        }
        return this.props.children;
    }
}

function RouteEffects() {
    const location = useLocation();
    useEffect(() => {
        if (location.hash) {
            const t = setTimeout(() => scrollToSection(location.hash.slice(1)), 350);
            return () => clearTimeout(t);
        }
        if (location.state && location.state.scrollTo) {
            const t = setTimeout(() => scrollToSection(location.state.scrollTo), 350);
            return () => clearTimeout(t);
        }
        scrollToTopImmediate();
    }, [location.pathname, location.hash, location.state]);
    return null;
}

function AppRouter() {
    const location = useLocation();
    // Google OAuth returns with #session_id — exchange it before anything else renders
    if (location.hash?.includes("session_id=")) return <AuthCallback />;
    return (
        <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/account" element={<Account />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="*" element={<Home />} />
        </Routes>
    );
}

export default function App() {
    useEffect(() => {
        initLenis();
    }, []);
    return (
        <ErrorBoundary>
            <AuthProvider>
                <BrowserRouter>
                    <RouteEffects />
                    <AppRouter />
                    <Toaster position="bottom-center" />
                </BrowserRouter>
            </AuthProvider>
        </ErrorBoundary>
    );
}
